export default "__VITE_ASSET__BAem1uDk__"